import type { SVGProps } from 'react';

/** Figma `metric-fatigue.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const MetricFatigueIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M1.63672 9.81925H4.09126L5.72763 4.91016L8.18217 14.7283L10.6367 7.3647L12.2731 9.81925H16.364"
        stroke="#FB2337"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
